import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ko from './locales/ko';
import mn from './locales/mn';
import en from './locales/en';

export const SUPPORTED_LANGS = ['ko', 'mn', 'en'] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];

const STORAGE_KEY = 'mp-lang';

function detectInitialLang(): Lang {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && (SUPPORTED_LANGS as readonly string[]).includes(stored)) {
      return stored as Lang;
    }
  } catch {
    /* localStorage unavailable */
  }
  return 'ko';
}

void i18n.use(initReactI18next).init({
  resources: {
    ko: { translation: ko },
    mn: { translation: mn },
    en: { translation: en },
  },
  lng: detectInitialLang(),
  fallbackLng: 'ko',
  interpolation: { escapeValue: false },
  returnNull: false,
  returnEmptyString: false,
});

export function setLang(lang: Lang): void {
  void i18n.changeLanguage(lang);
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* localStorage unavailable */
  }
}

export default i18n;
